import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import "../styles/main.css";
import "../styles/header.css";
import Logo from "../assets/images/wlogo.png";

const Header = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // ✅ Smart scroll handling for transparent → dark header
  useEffect(() => {
    const header = document.querySelector(".header");
    const handleScroll = () => {
      if (window.scrollY > 20) {
        header.classList.add("header--scrolled");
      } else {
        header.classList.remove("header--scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const ScrollItem = ({ to, children }) =>
    isHomePage ? (
      <ScrollLink
        to={to}
        smooth={true}
        duration={600}
        offset={-80}
        spy={true}
        activeClass="active-link"
      >
        {children}
      </ScrollLink>
    ) : (
      <Link to="/">{children}</Link>
    );

  return (
    <header className={`header ${isHomePage ? "header--transparent" : "header--blue"}`}>
      <div className="header-container">
            <div className="header-left">
        <div className="logo">
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>
</div>
        <button className="hamburger" aria-label="Toggle menu" onClick={toggleMobileMenu}>
          <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
          <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
          <span className={`bar ${isMobileMenuOpen ? "open" : ""}`}></span>
        </button>

        <div className="header-center">

<nav className={`nav ${isMobileMenuOpen ? "open" : ""}`}>
          <ul className="menu">
  <li>
    <ScrollItem to="hero">Home</ScrollItem>
  </li>

  <li
    className="has-submenu"
    onMouseEnter={() => setOpenMenu("insideBiz")}
    onMouseLeave={() => setOpenMenu(null)}
  >
    <span className="submenu-title">
      <ScrollItem to="why">Inside Bizverto</ScrollItem>
    </span>

    <ul className={`submenu ${openMenu === "insideBiz" ? "open" : ""}`}>
      <li><Link to="/about-us">About Us</Link></li>
      <li><Link to="/mission-vision">Mission & Vision</Link></li>
      <li><Link to="/why-choose-us">Why Choose Us</Link></li>
      <li><Link to="/industries">Industries We Serve</Link></li>
      <li><Link to="/client-success-stories">Client Success Stories</Link></li>
      <li><Link to="/blog-insights">Blog & Insights</Link></li>
    </ul>
  </li>

  <li
    className="has-submenu"
    onMouseEnter={() => setOpenMenu("services")}
    onMouseLeave={() => setOpenMenu(null)}
  >
    <span className="submenu-title">
      <ScrollItem to="services">Services</ScrollItem>
    </span>

    <ul className={`submenu ${openMenu === "services" ? "open" : ""}`}>

      <li className="has-submenu">
        <span className="submenu-title">HR Solutions</span>

        <ul className="submenu nested">
          <li><Link to="/services/hr/recruitment">Recruitment & Talent Acquisition</Link></li>
          <li><Link to="/services/hr/payroll">Payroll Management</Link></li>
          <li><Link to="/services/hr/policy">HR Policy Formulation</Link></li>
          <li><Link to="/services/hr/compliance">HR Compliance & Audit</Link></li>
          <li><Link to="/services/hr/performance">Performance Review System</Link></li>
          <li><Link to="/services/hr/management">Complete HR Function Management</Link></li>
          <li><Link to="/services/hr/automation">HR Set Up & Automation</Link></li>
        </ul>
      </li>

      <li className="has-submenu">
        <span className="submenu-title">IT Solutions</span>

        <ul className="submenu nested">
          <li><Link to="/services/it/website-design">Website Design & Maintenance</Link></li>
          <li><Link to="/services/it/digital-marketing">Digital Marketing</Link></li>
          <li><Link to="/services/it/email-campaign">Email Campaign</Link></li>
          <li><Link to="/services/it/content-writing">Content Writing</Link></li>
          <li><Link to="/services/it/seo">SEO & Online Visibility</Link></li>
        </ul>
      </li>

      <li className="has-submenu">
        <span className="submenu-title">Business Solutions</span>

        <ul className="submenu nested">
          <li><Link to="/services/business/proposals">Business Proposals</Link></li>
          <li><Link to="/services/business/business-plan">Investor Ready Business Plan</Link></li>
          <li><Link to="/services/business/market-research">Market Research</Link></li>
          <li><Link to="/services/business/process-optimization">Process Optimization</Link></li>
        </ul>
      </li>

    </ul>
  </li>

  <li>
    <Link to="/careers">Careers</Link>
  </li>

  <li>
    <Link to="/contact">Contact</Link>
  </li>

</ul>
        </nav>
        </div>
        <div className="header-right">

    <Link
        to="/contact"
        className="header-btn"
    >
        Let's Connect
        <span>→</span>
    </Link>

</div>
      </div>
    </header>
  );
};

export default Header;
